import { GoogleFormService } from './googleFormService';
import { EngraveSettings } from '../types';

export interface ClipboardReadResult {
  success: boolean;
  settings?: EngraveSettings;
  error?: string;
  message: string;
}

export class ClipboardService {
  private googleFormService = new GoogleFormService();

  async readAndParseFromClipboard(): Promise<ClipboardReadResult> {
    try {
      const text = await navigator.clipboard.readText();

      if (!text.trim()) {
        return {
          success: false,
          error: 'クリップボードが空です',
          message: 'JSON形式の設定をコピーしてください'
        };
      }

      const settings = this.googleFormService.deserializeSettings(text);

      if (!settings) {
        return {
          success: false,
          error: '設定の解析に失敗しました',
          message: '正しいJSON形式でコピーしてください'
        };
      }

      return {
        success: true,
        settings,
        message: '設定を読み込みました'
      };
    } catch (error) {
      if (error instanceof Error && error.name === 'NotAllowedError') {
        return {
          success: false,
          error: 'アクセス許可がありません',
          message: 'HTTPS接続またはブラウザ権限を確認してください'
        };
      }
      return {
        success: false,
        error: 'クリップボード読み込みエラー',
        message: 'もう一度お試しください'
      };
    }
  }
}
